import {
  UserProfileAddValpayCcDocument,
  UserProfileAddValpayCcMutationResult,
  UserProfileAddValpayCcMutationVariables,
} from "@graphql/api";

export default async function userProfileAddValpayCc(
  id: number,
  encryptedCardNumber: string,
  encryptedExpiryMonth: string,
  encryptedExpiryYear: string,
  encryptedSecurityCode: string,
  ccCardHolderName?: string,
  ccPostalCode?: string
): Promise<boolean> {
  const client = global.window.apolloClient;

  const mutVars: UserProfileAddValpayCcMutationVariables = {
    id,
    encryptedCardNumber,
    encryptedExpiryMonth,
    encryptedExpiryYear,
    encryptedSecurityCode,
    ccCardHolderName,
    ccPostalCode,
  };
  const result: UserProfileAddValpayCcMutationResult = await client.mutate({
    mutation: UserProfileAddValpayCcDocument,
    variables: mutVars,
  });

  if (result.data?.userProfileAddValpayCc.success) {
    // Reload the Apollo cache.
    await client.resetStore();
  }

  return result.data?.userProfileAddValpayCc.success;
}
